import type { CommandGroupWithActions } from "@replo/design-system/utils/commands";

import React from "react";

import twMerge from "@replo/design-system/utils/twMerge";
import { DEBUG_OPTIONS } from "@v2/features/debug/debugOptions";
import { useIsDebugMode } from "@v2/hooks/useIsDebugMode";
import { useLocalStorageState } from "@v2/hooks/useLocalStorage";
import { z } from "zod";

export function useDebugOptionsCommandItems(): CommandGroupWithActions["items"] {
  const isDebugMode = useIsDebugMode();

  if (!isDebugMode) {
    return {};
  }

  const items: CommandGroupWithActions["items"] = {};

  DEBUG_OPTIONS.forEach((option) => {
    // biome-ignore lint/correctness/useHookAtTopLevel: This is safe because the loop is deterministic and hooks are called in the same order
    const [value, setValue] = useLocalStorageState(option.key, false, {
      schema: z.boolean(),
    });

    items[option.key] = {
      label: `${option.label} (Currently ${value ? "ON" : "OFF"})`,
      icon: {
        type: "custom" as const,
        content: (
          <div className="flex h-[16px] w-[16px] items-center justify-center">
            <div
              className={twMerge(
                "h-[8px] w-[8px] rounded-full",
                value ? "bg-emerald-soft0" : "bg-surface",
              )}
            />
          </div>
        ),
      },
      onSelect: () => setValue(!value),
    };
  });

  return items;
}
